import { RouteObject } from "react-router-dom";
import Home from "../pages/Home/Home";
import CallBack from "../pages/Login/CallBack";
import Login from "../pages/Login/Login";
import AccessDenied from "../pages/AccessDenied/AccessDenied";
import NotFound from "../pages/NotFound/NotFound";
import ErrorServer from "../pages/ErrorServer/ErrorServer";
import Piramide from "../pages/Piramide/Piramide";
import History from "../pages/History/History";

const routers: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/login",
    children: [
      {path: "", element: <Login />},
      {path: "oauth2/code/cognito", element: <CallBack />}
    ]
  },
  {
    path: 'acceso-restringido',
    element: <AccessDenied />
  },
  {
    path: 'error-server',
    element: <ErrorServer />
  },
  {
    path: 'piramide',
    element: <Piramide />
  },
  {
    path: 'history',
    element: <History />
  },
  // {
  //   path: 'brief-iniciativas',
  //   element: <BriefInitiative />
  // },
  // {
  //   path: 'brief-tactico',
  //   element: <BriefTactic />
  // },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routers;
